import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import { IVendorOrderInformationData } from '../../../types/vendorDashboard/IVendorOrderInformation';

export interface IVendorOrderState {
  order: { [orderId: string]: IVendorOrderInformationData };
  orderFetchStatus: IFetchStatus;
  orderError?: string;
  sentToSpruceFetchStatus: IFetchStatus;
  sentToSpruceError?: string;
}

export const vendorOrderInitialState: IVendorOrderState = {
  order: {},
  orderFetchStatus: createDefaultFetch(),
  sentToSpruceFetchStatus: createDefaultFetch(),
};
